export default "__VITE_ASSET__kGXYPMJX__"